import { TranslatableKey } from '../translatable.type';

const IntegrationTypeDescriptionDisplayOptions: { [key: string]: TranslatableKey } = {
    'Job Board': 'settings.integration-card.description.jobBoard',
    'Accounting Software': 'settings.integration-card.description.accountingSoftware',
    'Automation Software': 'settings.integration-card.description.automationSoftware',
};

export { IntegrationTypeDescriptionDisplayOptions };
